module.exports = __webpack_public_path__ + "79bafab7900ff1311bfc4c4dbdf50c24.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/shopify-factory.svg
// module id = 619
// module chunks = 0